import { render } from "./AddAthleteToGroup.vue?vue&type=template&id=377f09e6"
import script from "./AddAthleteToGroup.vue?vue&type=script&lang=js"
export * from "./AddAthleteToGroup.vue?vue&type=script&lang=js"
script.render = render

export default script